import React from 'react';

import { Navigate } from 'react-router-dom';

import { uiRoutes } from '@consumer-frontend/nc-api';

export const HomePage: React.FC = () => <Navigate replace to={uiRoutes.apply.borrowingNeeds} />;
